import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

export default function Error403() {
  const [pageData, setPageData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    document.title = "Ingen adgang - Havneloppen";
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute("content", "Du har ikke adgang til denne side på Havneloppen.");
    }

    fetch("https://api.dev.auxo.dk/public/content/sider")
      .then((res) => res.json())
      .then((data) => {
        if (Array.isArray(data)) {
          const page = data.find((p) => p.url_slug === "403");
          setPageData(page);
        }
      })
      .catch((err) => console.error("Error fetching 403 page data:", err))
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className="flex min-h-[60vh] items-center justify-center">
        <i className="fa-solid fa-spinner animate-spin text-4xl text-brand-orange" />
      </div>
    );
  }

  return (
    <div className="mx-auto max-w-md px-6 py-20 text-center space-y-6">
      <div className="inline-flex h-20 w-20 items-center justify-center rounded-full bg-rose-100 text-rose-600">
        <i className="fa-solid fa-lock text-3xl" />
      </div>
      <h1 className="font-display text-3xl font-extrabold text-brand-blue">
        {pageData?.titel || "Ingen adgang (403)"}
      </h1>
      <div
        className="prose text-dark-graphite-light text-sm leading-relaxed"
        dangerouslySetInnerHTML={{ __html: pageData?.indhold || "" }}
      />
      <div className="pt-4">
        <Link
          to="/"
          className="rounded-lg bg-brand-orange px-5 py-2.5 text-sm font-bold text-warm-white hover:bg-brand-orange-hover transition-colors shadow-sm"
        >
          Gå til forsiden
        </Link>
      </div>
    </div>
  );
}
